/* eslint-disable max-len */
import * as React from "react";

interface Props {
    className?: React.HTMLAttributes<SVGAElement>["className"];
}

export default function Logo({ className }: Props): JSX.Element {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 800 220"
            className={className}
        >
            <path
                className="fill-shamrock-400"
                d="M189.59,110.49v-.3c0-29.79,24-53.95,56-53.95s55.73,23.87,55.73,53.66v.29c0,29.8-24,53.95-56,53.95S189.59,140.28,189.59,110.49Zm82.41,0v-.3c0-15-10.82-28-26.68-28-15.71,0-26.24,12.75-26.24,27.72v.29c0,15,10.82,28,26.53,28S272,125.46,272,110.49Z"
            />
            <path
                className="fill-shamrock-400"
                d="M324.63,55.86h30.12v82.28h52.62v26.39H324.63Z"
            />
            <path
                className="fill-shamrock-400"
                d="M428,55.86h30.11v82.28h52.63v26.39H428Z"
            />
            <path
                className="fill-shamrock-400"
                d="M531.4,55.86h87.4V81.48H561.21V97.93h52.16v23.75H561.21v17.23h58.37v25.62H531.4Z"
            />
            <path
                className="fill-shamrock-400"
                d="M674.06,123.85l-41.29-68h34.31l22.35,39.59,22.51-39.59h33.69l-41.3,67.53v41.14H674.06Z"
            />
            <path
                className="fill-shamrock-400"
                d="M165.67,55.47H153.85L126.78,102.3A13.17,13.17,0,1,1,104,89.12l19.45-33.65H65.25a10.86,10.86,0,0,0-9.4,16.3l50.21,86.87a10.86,10.86,0,0,0,18.8,0l50.21-86.87A10.87,10.87,0,0,0,165.67,55.47Z"
            />
        </svg>
    );
}
Logo.defaultProps = { className: undefined };
